<template>
  <div class="checkbox-wrapper" @click="toggle">
    <span
      class="checkbox"
      :class="{'is--checked': checked}"
      :style="{ width: size + 'px', height: size + 'px' }"
    >
      <i class="ri-check-line" v-if="checked"></i>
    </span>
    <span class="checkbox-label" v-if="label">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'Checkbox',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: 24
    },
    label: {
      type: String,
      default: ''
    }
  },
  computed: {
    checked() {
      return this.value;
    }
  },
  methods: {
    toggle() {
      this.$emit('input', !this.value);
      this.$emit('change', !this.value);
    }
  }
}
</script>

<style lang="scss" scoped>
.checkbox-wrapper {
  display: flex;
  align-items: center;
  cursor: pointer;
  
  .checkbox {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 9px;
    background: var(--label-quarternary);
    border: 1px solid var(--label-quarternary);
    border-radius: 3px;
    flex-shrink: 0;
    
    i {
      font-size: 18px;
      vertical-align: middle;
      opacity: 0;
      color: var(--light-01);
      transition: opacity 0.2s;
    }
    
    &.is--checked {
      background: var(--accent-blue);
      i {
        opacity: 1;
      }
    }
  }
  
  .checkbox-label {
    font-size: 12px;
    line-height: 16px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: var(--label-primary);
  }
}
</style>
